export default {
  // App Config
  SET_APP_CONFIG: 'SET_APP_CONFIG',
  SET_APP_CONSENT: 'SET_APP_CONSENT',

  // Logout State
  SET_LOGOUT_STATE: 'SET_LOGOUT_STATE',

  // Current logout time
  SET_CURRENT_LOGOUT_TIME: 'SET_CURRENT_LOGOUT_TIME',

  // Overlay
  SHOW_OVERLAY: 'SHOW_OVERLAY',
  HIDE_OVERLAY: 'HIDE_OVERLAY',

  // Basket
  SHOW_BASKET: 'SHOW_BASKET',
  HIDE_BASKET: 'HIDE_BASKET',

  // Portal Targets set from anywhere and rendered in root
  ADD_PORTAL_TARGET: 'ADD_PORTAL_TARGET',

  // Navigation
  SHOW_NAVIGATION_DRAWER: 'SHOW_NAVIGATION_DRAWER',
  HIDE_NAVIGATION_DRAWER: 'HIDE_NAVIGATION_DRAWER',

  // Search
  // SHOW_SEARCH_DIALOG: 'SHOW_SEARCH_DIALOG',
  // HIDE_SEARCH_DIALOG: 'HIDE_SEARCH_DIALOG',
  // SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  // SET_SEARCH_PAGE: 'SET_SEARCH_PAGE',
  // SET_SEARCH_URL: 'SET_SEARCH_URL',
  // SET_SEARCH_QUERY_MIN_LENGTH: 'SET_SEARCH_QUERY_MIN_LENGTH', // ToDo: Remove
  SET_SEARCH_IMMEDIATE: 'SET_SEARCH_IMMEDIATE',
  // SET_SEARCH_IS_OVERVIEW: 'SET_SEARCH_IS_OVERVIEW',
  // SET_SEARCH_BODY_CLASS: 'SET_SEARCH_BODY_CLASS',
  TRACK_GTM_EVENT: 'TRACK_GTM_EVENT',

  // Product List
  SET_PRODUCT_LIST_VIEW: 'SET_PRODUCT_LIST_VIEW',
  SET_PRODUCT_GRID_VIEW: 'SET_PRODUCT_GRID_VIEW',

  // Dimensions
  SET_DIMENSION: 'SET_DIMENSION',

  // Notifications
  // OPEN_NOTIFICATION_MESSAGE: 'OPEN_NOTIFICATION_MESSAGE',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',

  CHANGE_SCOPE: 'CHANGE_SCOPE',
  GET_SCOPE_FILTER: 'GET_SCOPE_FILTER',
  GET_ALL_FILTER: 'GET_ALL_FILTER',

  // News
  GET_NEWS_UNREAD: 'GET_NEWS_UNREAD',

  GET_PAYMENT_TERMS: 'GET_PAYMENT_TERMS',
  SET_SELECTED_BRAND: 'SET_SELECTED_BRAND',
  GET_ENVIRONMENT_DATA: 'GET_ENVIRONMENT_DATA',
}
